import React from 'react';
import { Link } from 'react-router-dom';

function NotFoundPage() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      color: 'white',
      textAlign: 'center',
      fontFamily: 'Arial, sans-serif',
      padding: '0 20px'
    }}>
      <h1 style={{
        fontSize: '8rem',
        margin: 0,
        animation: 'bounce 2s infinite'
      }}>404</h1>
      <p style={{
        fontSize: '1.5rem',
        marginBottom: '2rem'
      }}>Ups! Strona, której szukasz, nie istnieje.</p>
      <Link to="/" style={{
        padding: '10px 25px',
        backgroundColor: '#ff6b6b',
        color: 'white',
        borderRadius: '5px',
        textDecoration: 'none',
        fontWeight: 'bold',
        transition: '0.3s'
      }}
      onMouseEnter={e => e.target.style.backgroundColor = '#ff4757'}
      onMouseLeave={e => e.target.style.backgroundColor = '#ff6b6b'}
      >
        Powrót do strony głównej
      </Link>

      <style>
        {`
          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
            40% { transform: translateY(-20px); }
            60% { transform: translateY(-10px); }
          }
        `}
      </style>
    </div>
  );
}

export default NotFoundPage;